module.exports = __webpack_public_path__ + "media/images/bg/pattern-3884166b5fa1f2feac9115a116248c9c.svg";